import React from "react";
import templates from "../data/templates";

const TemplatePicker = ({ selectedId, onChange }) => {
  return (
    <div>
      <label className="block font-semibold mb-2">Choose a Template</label>
      <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-4">
        {templates.map((template) => (
          <div
            key={template.id}
            className={`cursor-pointer border-2 rounded-xl p-2 ${
              selectedId === template.id ? "border-pink-500" : "border-gray-200"
            }`}
            onClick={() => onChange(template.id)}
          >
            {template.preview ? (
              <img
                src={template.preview}
                alt={template.name}
                className="rounded mb-2 w-full h-24 object-cover"
              />
            ) : (
              <div
                className={`rounded mb-2 w-full h-24 ${template.previewClass || template.background}`}
              />
            )}
            <div className="flex items-center justify-center gap-2">
              <span
                className="h-3 w-3 rounded-full border border-white shadow"
                style={{ backgroundColor: template.accentColor || "#ec4899" }}
              />
              <p className="text-center font-medium">{template.name}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TemplatePicker;
